export default "__VITE_ASSET__b2RRCi7t__"